/** Per-token prices from prices.json (refreshed by `pnpm prices:sync`). */
import type { ModelPrice, PriceList } from '../../scripts/pricing.ts';
import { MODEL_FAMILIES } from './models';
import data from './prices.json';

export const PRICES: PriceList = data;

export const priceOf = (model: string): ModelPrice | undefined => PRICES.perToken[model];

/** Cheapest input price among the models the site lists. */
export const LOWEST_INPUT_PRICE = Math.min(
  ...MODEL_FAMILIES.flatMap((family) => family.models)
    .map((model) => priceOf(model)?.input)
    .filter((price): price is number => price !== undefined),
);

/** $8.14, $0.44, $0.044, $0.0058: always two significant digits below a dollar. */
export function formatUsd(value: number): string {
  const digits = value >= 1 ? 2 : Math.max(2, 1 - Math.floor(Math.log10(value)));
  return `$${value.toFixed(digits)}`;
}
